// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yAUHY","col":"styles_col__2EOBh","actions":"styles_actions__1fSjG","conflict":"styles_conflict__PuvD2"};